import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBInput

}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import Popup from '../../Popup/popUp';


function AreaCheckin() {
  const utils = require('../../../utils/index');
  const user = utils.getUser();
  const navigate = useNavigate();

  const api = require('../../../apis/responsavel')

  const [showPopup, setShowPopup] = useState(false);
  const [data, setData] = useState([]);


  const handlePopupClose = () => {
    setShowPopup(false);
    setData([]);
  };
  
  const handleClick = async(obj) => {
    setData([]);
    setShowPopup(false);
    navigate("/criar-checkin-distancia", { state: { obj } })
  }

  const handleButtonClick = async () => {
    const getAlunos = async () => {
      try {
        const object = {
          cpf: user.cpf
        };
        const response = await api.pegarFilialPorResponsavel(object);
        const data = await response;
        if(data != false){
          setData(data);
        }
        else{
          throw new Error("Erro desconhecido");
        }
      } catch (error) {
        toast.error('Erro ao obter dados:', error);
        navigate("/home")
        return
      }
    };
    await getAlunos();
    setShowPopup(true)

  };

  return (
    <div className="w-75 d-flex justify-content-center align-items-center mx-auto my-auto" style={{height:'90vh'}}>
      <MDBCard className='bg-dark w-100 p-5' style={{minWidth:'350px'}}>
        <MDBCardBody className='bg-dark w-100'>
          <MDBCardTitle className='text-white'>Bem vindo, {utils.decideName(user)}</MDBCardTitle>
          <MDBCardText className='text-white'>
            O que veio fazer?
          </MDBCardText>
          <div className="d-grid gap-3 w-100">
            <MDBBtn 
              className='btn-home w-100'
              size='lg'
              outline 
              color='white' 
              disabled={user.tipouser != 6}
              onClick={() => {
                navigate("/criar-checkin")
              }}
              
              >Criar checkin</MDBBtn>
              <MDBBtn 
              className='btn-home w-100'
              size='lg'
              outline 
              color='white' 
              disabled={user.tipouser != 1}
              
              onClick={handleButtonClick}

              >Checkin a distancia</MDBBtn>
              <Popup show={showPopup} handleClose={handlePopupClose}>

                <div className='d-flex justify-content-center flex-column align-items-center w-100'>
                  {data.map((user) => (
                    <div className='d-flex justify-content-between m-2 flex-row align-items-between w-100' key={user.id}>
                      <MDBInput 
                        className='w-100 bg-dark'
                        labelClass='text-white' 
                        label='Filial' id='formControNomeFilial' 
                        type='text' 
                        size="lg" 
                        style={{color:"white", opacity:0.6}}
                        name='nomeFilial'
                        value={user.nomefilial}
                        required
                        disabled={true}
                        minLength={3}
                      
                      />
                      <MDBBtn 
                      className='btn-home w-50'
                      size='sm'
                      outline 
                      type='button'
                      color='white' 
                      onClick={() => handleClick(user)}
                      >Selecionar</MDBBtn>
                    </div>
                  ))}
                  
                </div>
              </Popup>
            <MDBBtn 
              className='btn-home w-100'
              size='lg'
              outline 
              color='white'
              disabled={user.tipouser == 1}
              onClick={() => {
                navigate("/listar-checkin")
              }} 
              >Listar checkins</MDBBtn>
              <MDBBtn 
              className='btn-home w-100 mt-4'
              size='sm'
              outline 
              color='white' 
              onClick={() => {
                navigate("/home")
              }}
              >Voltar</MDBBtn>
          </div>
        </MDBCardBody>
        
      </MDBCard>
    </div>
  );
}

export default AreaCheckin;